import { render } from "./SearchResultView.vue?vue&type=template&id=66def556&scoped=true"
import script from "./SearchResultView.vue?vue&type=script&lang=js"
export * from "./SearchResultView.vue?vue&type=script&lang=js"

import "./SearchResultView.vue?vue&type=style&index=0&id=66def556&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66def556"]])

export default __exports__